<template src="./plan.html"></template>

<script>
import PlanFrequencySelect from '@/components/common/PlanFrequencySelect.vue';

export default {
  name: 'plan',
  components: { PlanFrequencySelect },
  data() {
    return {
      interval: 'yearly',
      frequencyOptions: [
        {
          value: 'yearly',
          label: 'Yearly',
          mostPopular: true,
          originalPrice: '$1020.00',
          price: '$820.00 /year',
          priceSub: '$68.30 /month'
        },
        {
          value: 'monthly',
          label: 'Monthly',
          mostPopular: false,
          price: '$85.00 /month'
        }
      ]
    };
  },
  methods: {
    continueToPayment() {
      this.$router.push({ path: '/settings/payment', query: { interval: this.interval } });
    }
  }
};
</script>

<style scoped>
.plan-page {
  padding-bottom: 1rem;
}
.plan-page-h1-row {
  margin-bottom: 0;
}
.plan-page-content-row {
  margin-top: 1rem;
}
.plan-page__heading {
  margin-bottom: 0.75rem;
  font-weight: 600;
}
.plan-page__features {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.5;
  color: var(--color-text);
}
.plan-page__features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.plan-page__check-icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: block;
}
.plan-page-divider {
  margin: 2rem 0 0 0;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.plan-page-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;
  padding-top: 0;
}
.plan-page-actions .plan-page-continue-btn {
  height: 36px;
  line-height: 36px;
  padding-top: 0;
  padding-bottom: 0;
}
@media (max-width: 767px) {
  .plan-page-actions {
    justify-content: stretch;
  }
  .plan-page-actions .plan-page-continue-btn {
    width: 100%;
  }
}
</style>
